import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  DialogActions,
  FormControl,
  FormGroup,
  Grid,
  Tooltip,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import Fab from "@material-ui/core/Fab";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Add from "@material-ui/icons/Add";
import Search from "@material-ui/icons/Search";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { mapActionsToProps as CallflowAction } from "../../redux/cloudPBX/callFlow";
import { mapActionsToProps as CallflowNumberAction } from "../../redux/cloudPBX/callflowNumber";
import { mapActionsToProps as WorktimeAction } from "../../redux/cloudPBX/workTime";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  bulletOffline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "red",
  },
  bulletOnline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "chartreuse",
  },
  dayItem: {
    // padding: '10px',
    border: "1px solid #9a9a9a",
    margin: "15px",
    width: "40px",
    height: "25px",
    display: "inline-block",
    textAlign: "center",
    lineHeight: "25px",
    cursor: "pointer",
    borderRadius: "5px",
    fontSize: "13px",
  },
});

class CallflowNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      description: "",
      actions: [{}],
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      modalDelete: false,
      showpassword: false,
      modalAction: false,
      menuItems: [],
      parameters: [],
      validateDate: false,
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
    this.props.getListCallflow();
    this.props.getListWorktime();
  }

  listCollumns = [
    { id: "title", numeric: true, disablePadding: false, label: "Đầu số" },
    { id: "title", numeric: true, disablePadding: false, label: "Tên gợi nhớ" },
    { id: "title", numeric: true, disablePadding: false, label: "Bộ phận" },
    {
      id: "lastUpdate",
      numeric: true,
      disablePadding: false,
      label: "Thời gian cập nhật",
    },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "title":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getListCallflowNumber(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      }
    );
    this.props.countListCallflowNumber({ where });
  }

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({
      modalSend: false,
      modalAction: false,
      modalDelete: false,
      title: "",
      description: "",
      actions: [{}],
      validateDate: false,
    });
  };

  openModalEdit = (item) => {
    this.setState({ selectedSubOrg: "" });
    this.state.item = item;
    this.setState({ modalAction: true });
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = { like: value };
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  handleCreateModel = () => {
    this.setState({ modalAction: true, item: {}, menuItems: [] });
  };

  handleAction = () => {
    const { id } = this.state.item;
    if (!id) {
      let { title, actions } = this.state;
      actions = actions.map((a) => {
        a.number = title;
      });
      return (
        this.props.addCallflowNumber(title, actions),
        setTimeout(
          function () {
            this.setState({
              modalAction: false,
              title: "",
              actions: [{}],
              validateDate: false,
            });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    } else {
      let { id, title, actions } = this.state.item;
      actions = actions.map((a) => {
        a.number = title;
      });
      return (
        this.props.editCallflowNumber(id, title, actions),
        setTimeout(
          function () {
            this.setState({
              modalAction: false,
              title: "",
              actions: [{}],
              validateDate: false,
            });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    }
  };

  handleDelete = () => {
    this.props.deleteWorktime(this.state.item.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  handleAddTime = (isEdit) => {
    let actions = isEdit ? this.state.item.actions : this.state.actions;

    actions.push({});

    if (!isEdit) {
      this.setState({
        actions: actions,
      });
    } else {
      this.setState({
        item: {
          ...this.state.item,
          actions: actions,
        },
      });
    }
  };

  handleDeleteDate = (index, isEdit) => {
    if (isEdit) {
      const { item } = this.state;
      item.actions.splice(index, 1);
      this.setState({ item });
    } else {
      const { actions } = this.state;
      actions.splice(index, 1);
      this.setState({ actions });
    }
  };

  handleChangeAction = (value, index, field) => {
    const { actions } = this.state;
    actions[index][field] = value;
    this.setState({
      actions,
    });
  };

  render() {
    const { classes } = this.props;
    const { title, filters, item, modalDelete, description } = this.state;
    const action = item
      ? item.id
        ? item.actions
        : this.state.actions
      : this.state.actions;
    const isEdit = item ? (item.id ? true : false) : false;

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item md={3}>
                        <TextValidator
                          id="outlined-full-width"
                          margin="normal"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Đầu số"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={
                            filters.where.title ? filters.where.title.like : ""
                          }
                          name="title"
                        />
                      </Grid>
                      <Grid item md={3}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách giờ làm việc"
          items={this.props.callflowNumbers}
          rowsPerPage={filters.pageSize}
          count={this.props.count ? this.props.count.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={false}
          allowEdit={true}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          createAction={
            // <> </>
            <Tooltip title="Thêm mới" disableFocusListener>
              <Fab
                color="primary"
                aria-label="add"
                className={classes.fab}
                size="small"
                onClick={this.handleCreateModel}>
                <Add className={classes.add} />
              </Fab>
            </Tooltip>
          }
        />
        <Dialog
          open={this.state.modalAction}
          title={
            item
              ? item.id
                ? "Chỉnh sửa thiết lập call flow cho đầu số"
                : "Thiết lập call flow cho đầu số"
              : null
          }
          maxWidth={"md"}
          fullWidth={true}
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <Grid item md={12} style={{ padding: 5 }}>
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label="Tên gợi nhớ"
                      variant="outlined"
                      className={classes.input}
                      onChange={
                        item
                          ? item.id
                            ? this.handleChangeTextEdit("title")
                            : this.handleChangeText("title")
                          : null
                      }
                      value={item ? (item.id ? item.title : title) : null}
                      validators={["required"]}
                      errorMessages={["Không được để trống"]}
                    />
                  </Grid>

                  <Grid
                    container
                    md={12}
                    style={{ background: "rgba(245, 245, 245, 1)" }}>
                    <Grid item md={12} style={{ padding: 5 }}>
                      <Typography>Call flow trong giờ làm việc</Typography>
                    </Grid>
                    {action.map((a, index) => {
                      return (
                        <Grid
                          key={index}
                          container
                          item
                          md={12}
                          style={{
                            padding: 5,
                            marginTop: "10px",
                            display: "flex",
                            justifyContent: "space-between",
                          }}>
                          <Grid item md={4}>
                            <SelectValidator
                              margin="normal"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              select
                              required
                              label={"Chọn khung giờ"}
                              fullWidth
                              variant="outlined"
                              className={classes.input}
                              onChange={(e) =>
                                this.handleChangeAction(
                                  e.target.value,
                                  index,
                                  "timeId"
                                )
                              }
                              value={a.timeId}
                              name={"toWorkTime"}
                              validators={["required"]}
                              errorMessages={[`Không được để trống`]}>
                              {this.props.worktimes.map((i, key) => {
                                return (
                                  <MenuItem key={key} value={i.id}>
                                    {i.title}
                                  </MenuItem>
                                );
                              })}
                            </SelectValidator>
                          </Grid>
                          <Grid item md={2}></Grid>
                          <Grid item md={4}>
                            <SelectValidator
                              margin="normal"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              select
                              required
                              label={"Chọn call flow"}
                              fullWidth
                              variant="outlined"
                              className={classes.input}
                              onChange={(e) =>
                                this.handleChangeAction(
                                  e.target.value,
                                  index,
                                  "dialPlanId"
                                )
                              }
                              value={a.dialPlanId}
                              name={"toCallFlow"}
                              validators={["required"]}
                              errorMessages={[`Không được để trống`]}>
                              {this.props.callflows.map((i, key) => {
                                return (
                                  <MenuItem key={key} value={i.id}>
                                    {i.title}
                                  </MenuItem>
                                );
                              })}
                            </SelectValidator>
                          </Grid>
                          <Grid item md={1}></Grid>
                          {
                            // action.length > 1 && <Grid item md={1}><DeleteIcon style={{cursor:'pointer', marginTop: '25px'}} onClick={() => this.handleDeleteDate(index, isEdit)} /></Grid>
                          }
                        </Grid>
                      );
                    })}
                    {this.state.validateDate && (
                      <Typography style={{ color: "red", fontSize: "12px" }}>
                        {" "}
                        Không được để trống ngày làm việc{" "}
                      </Typography>
                    )}

                    <Grid item md={12} style={{ padding: 5 }}>
                      <Typography>Thêm khung giờ </Typography>
                      <Fab
                        color="primary"
                        aria-label="add"
                        className={classes.fab}
                        size="small"
                        onClick={() => this.handleAddTime(isEdit)}>
                        <Add className={classes.add} />
                      </Fab>
                    </Grid>
                  </Grid>
                  {/*                                     
                                    <Grid item md={12} style={{ padding: 5 }}>
                                        <TextValidator
                                            id="outlined-full-width"
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            multiline
                                            rows={3}
                                            label="Ghi chú"
                                            variant="outlined"
                                            className={classes.input}
                                            onChange={!!item ? (item.id ? this.handleChangeTextEdit('description') : this.handleChangeText('description')) : null}
                                            value={!!item ? (item.id ? item.description : description) : null}
                                        />
                                    </Grid> */}
                </Grid>
              </FormControl>
              <DialogActions>
                <Button
                  onClick={this.handleClose}
                  color="secondary"
                  className={classes.button}>
                  Hủy
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}>
                  Lưu
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
          onClose={this.handleClose}
        />
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
      </React.Fragment>
    );
  }
}

CallflowNumber.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  count: state.workTime.count,
  callflowNumbers: state.workTime.callflowNumbers,
  callflows: state.callFlow.callflows,
  worktimes: state.workTime.worktimes,
});

CallflowNumber = connect(mapStateToProps, CallflowNumberAction)(CallflowNumber);
CallflowNumber = connect(mapStateToProps, WorktimeAction)(CallflowNumber);
CallflowNumber = connect(mapStateToProps, CallflowAction)(CallflowNumber);

export default withStyles(styles)(CallflowNumber);
